
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>

  <div>
    <div v-for="(menuItem, index) in data" :key="menuItem.id">

      <!-- рисует элемент меню и для FULLWIDTH и для NARROW -->
      <Menu-item :name="menuItem.id" v-if='menuItem.children == null'>
        <i :class="[menuItem.icon, { 'menuitem-icon':((lvl != 1) || (mainMenuType.value == mainMenuType.FULLWIDTH)),
                                     'menuitem-icon-big':((lvl == 1) && (mainMenuType.value == mainMenuType.NARROW))}]"></i>
        <span class="menuitem-text" v-if='(mainMenuType.value == mainMenuType.FULLWIDTH) || (lvl != 1)'>{{menuItem.name}}</span>
        <Button type="text" @click="deleteItemOnClick(menuItem.id)" class="menuitem-close-button" v-if='(menuItem.closable == true)'>
          <Icon type="close-round"></Icon>
        </Button>
      </Menu-item>

      <!-- рисует элемент меню как submenu только для FULLWIDTH -->
      <Submenu :name="menuItem.id" v-if='(menuItem.children != null) && (menuItem.isGroup != true) && (mainMenuType.value == mainMenuType.FULLWIDTH)'>
        <template slot="title">
          <Icon :type="menuItem.icon" class="menuitem-icon"></Icon>
          <span class="menuitem-text">{{menuItem.name}}</span>
          <Button type="text" @click="deleteItemOnClick(menuItem.id)" class="menuitem-close-button" v-if='(menuItem.closable == true)'>
            <Icon type="close-round"></Icon>
          </Button>
          <span class='menuitem-space-instead-close-button' v-if='(menuItem.closable != true)'>&nbsp;</span>
        </template>
        <MainMenuItems :data="menuItem.children" :lvl="lvl+1" :deleteItemOnClick='deleteItemOnClick'/>
      </Submenu>

      <!-- рисует элемент меню как groupmenu и для FULLWIDTH и для NARROW -->
      <Menu-group :title="menuItem.name" v-if='((mainMenuType.value == mainMenuType.NARROW) && (menuItem.children != null) && (menuItem.isGroup == true) && (lvl != 1)) ||
                                               ((mainMenuType.value == mainMenuType.FULLWIDTH) && (menuItem.children != null) && (menuItem.isGroup == true))'>
        <MainMenuItems :data="menuItem.children" :lvl="lvl+1" :deleteItemOnClick='deleteItemOnClick'/>
      </Menu-group>

      <!-- рисует элемент меню как submenu или groupmenu только для NARROW -->
      <Poptip trigger="hover" placement="right" class="nostyle-poptip poptip-as-menuitem"
        v-if='((mainMenuType.value == mainMenuType.NARROW) && (menuItem.children != null) && (menuItem.isGroup == true) && (lvl == 1)) ||
              ((mainMenuType.value == mainMenuType.NARROW) && (menuItem.children != null) && (menuItem.isGroup != true))'>
        <Menu-item :name="menuItem.id">
          <Icon :type="menuItem.icon" :class="{'menuitem-icon':lvl != 1,'menuitem-icon-big':lvl == 1}"></Icon>
          <span class="menuitem-text" v-if='lvl != 1'>{{menuItem.name}}</span>
          <Button type="text" @click="deleteItemOnClick(menuItem.id)" class="menuitem-close-button" v-if='(menuItem.closable == true) && (lvl != 1)'>
            <Icon type="close-round"></Icon>
          </Button>
          <span class='menuitem-space-instead-close-button' v-if='(menuItem.closable != true) && (lvl != 1)'>&nbsp;</span>
          <Icon type="chevron-right" class="poptip-submenu-arrow" v-if='lvl != 1'></Icon>
        </Menu-item>
        <div slot="content" class='mainmenu ivu-menu ivu-menu-dark ivu-menu-vertical poptip-content-panel'>
          <MainMenuItems :data="menuItem.children" :lvl="lvl+1" :deleteItemOnClick='deleteItemOnClick'/>
        </div>
      </Poptip>

    </div>
  </div>

</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'MainMenuItems',
  props: ['data', 'lvl', 'deleteItemOnClick'], // data - объект с пунктами меню lvl - уровень вложенности меню (от этого стиль меняется). значения: 1, 2, 3...
  computed: {
    ...mapGetters([
      'mainMenuType'
    ])
  }
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// MainMenuItems.vue?bbfc057a